import { put, select, takeLatest } from 'redux-saga/effects'
import { setService, setUserId } from '../../user/store/user.actions'
import Logger from '../../../services/logger.service'
import { getServicesSelector } from '../selectors'
import { IServiceList } from '../store/serviceSelection.types'
import { getUserSelector } from '../../user/selectors'
import { ServiceConstants } from '../store/serviceSelection.constants'
import LocalStorageService from '../../../services/localStorage.service'

export function* setServices() {
  const transformedUserServices: IServiceList = yield select(getServicesSelector)
  const { databaseUserName } = yield select(getUserSelector)
  if (transformedUserServices.length) {
    const { userId } = transformedUserServices[0]

    LocalStorageService.setItemForUserIdAndCleanDatabaseUserName(
      userId.toString(),
      databaseUserName,
      'serviceList',
      JSON.stringify(transformedUserServices)
    )

    yield put(setUserId(userId))

    Logger.sensitive(
      transformedUserServices,
      `setServices - userId: ${userId} belongs to ${transformedUserServices.length} services`
    )

    if (transformedUserServices.length === 1) {
      const { id, name } = transformedUserServices[0]
      yield put(setService(id, name))
    }
  }
}

export function* setServicesSaga() {
  yield takeLatest([ServiceConstants.SET_SERVICES_LIST], setServices)
}
